import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=25b09e6a&scoped=true"
import script from "./Keyboard.vue?vue&type=script&lang=js"
export * from "./Keyboard.vue?vue&type=script&lang=js"
import style0 from "./Keyboard.vue?vue&type=style&index=0&id=25b09e6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b09e6a",
  null
  
)

export default component.exports